export default __webpack_public_path__ + "static/media/mocktest_icon.330cc034.svg";